/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_ClientsInputs */

const cs_import_stat_clients = /** @type {(inputs: Import_Stat_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Klienti: ${i?.count}`)
};

const en_import_stat_clients = /** @type {(inputs: Import_Stat_ClientsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Clients: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Clients: {count}" |
*
* @param {Import_Stat_ClientsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_clients = /** @type {((inputs: Import_Stat_ClientsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_ClientsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_clients(inputs)
	return cs_import_stat_clients(inputs)
});